import React, { useEffect, useState, useContext } from "react";
import HeaderDashboard from '../Components/HeaderDashboard'
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../Routes/AuthProvider"
import { GetApprovalRequest } from '../Services/ApprovalAPI';
import { AcceptApprovalRequest } from '../Services/ApprovalAPI';
import { RejectApprovalRequest } from '../Services/ApprovalAPI';

const Approval = () => {
    const navigate = useNavigate();
    const { name, userName, roles } = useContext(AuthContext);
    const [remark, setRemark] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        status: "",
    });

    const [approvals, setApprovals] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    // Convert "dd/mm/yy" or "dd/mm/yyyy" → Date object
    const convertToDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    useEffect(() => {
        handleSearch();
        $("#fromDate").datepicker({
            dateFormat: "dd/mm/yy",
            // changeMonth: true,
            // changeYear: true,
            // maxDate: new Date(),
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    fromDate: dateText,
                }));
            },
        });
    }, []);

    useEffect(() => {
        $("#toDate").datepicker({
            dateFormat: "dd/mm/yy",
            //minDate: filters.fromDate,
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    toDate: dateText,
                }));
            },
        });
    }, []);

    // UPDATE minDate of ToDate WHEN fromDate changes
    useEffect(() => {
        if (filters.fromDate) {
            const minD = convertToDate(filters.fromDate);
            $("#toDate").datepicker("option", "minDate", minD);
        }
    }, [filters.fromDate]);


    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                BookingStatus: filters.status,
                UserName: userName,
            };
            //console.log("requestBody:", requestBody);
            const data = await GetApprovalRequest(requestBody);

            const list = data?.allApprovals || [];
            setApprovals(list);

        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };


    const SubmitAcceptApprovalRequest = async (item) => {
        const { referenceNo, level1ApproverId, level1ApproverName, level1ApproverBy, level1ApproverEmail, level2ApproverId, level2ApproverName, level2ApproverBy, level2ApproverEmail, userId, product } = item;
        //const { referenceNo, level1Approver, level1ApproverEmail, userId, product } = item;
        setLoading(true);
        try {
            const requestBody = {
                referenceNo: referenceNo,
                level1ApproverEmail: level1ApproverEmail,
                level1ApproverType: level1ApproverId,
                level2ApproverEmail: level2ApproverEmail,
                level2ApproverType: level2ApproverId,
                product: product,
                UserId: userName,
                ApprovalRequestedByUserName: userId,
                ApprovalRequestedByEmail: ""
            };
            //console.log("requestBody:", requestBody);
            const data = await AcceptApprovalRequest(requestBody);
            if (data.message === "Booking Success" || data.message === "Booking Success") {
                if (data.productType === "Flight") {
                    navigate(`/thankyou?ReferenceNo=${referenceNo}`);
                } else {
                    navigate(`/bus/thankyou?ReferenceNo=${referenceNo}`);
                }
            } else {
                alert(data.message);
                navigate(`/approval`);
            }
            //console.log("AcceptApprovalRequest:", data);
            //navigate(`/thankyou?ReferenceNo=${referenceNo}`);
            // const list = data?.allApprovals || [];
            // setApprovals(list);

        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const SubmitRejectApprovalRequest = async (item) => {
        if (!remark) {
            alert("Remark Required");
            return;
        }
        if (!item) {
            alert("Invalid approval data");
            return;
        }
        const { referenceNo, level1ApproverId, level1ApproverName, level1ApproverBy, level1ApproverEmail, level2ApproverId, level2ApproverName, level2ApproverBy, level2ApproverEmail, userId, product } = item;
        const modalElement = document.getElementById("myModal");
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        modalInstance.hide();
        setLoading(true);
        try {
            const requestBody = {
                referenceNo: referenceNo,
                level1ApproverEmail: level1ApproverEmail,
                level1ApproverType: level1ApproverId,
                level2ApproverEmail: level2ApproverEmail,
                level2ApproverType: level2ApproverId,
                product: product,
                UserId: userName,
                remark: remark,
                ApprovalRequestedByUserName: userId,
                ApprovalRequestedByEmail: ""
            };
            //console.log("requestBody:", requestBody);
            const data = await RejectApprovalRequest(requestBody);
            alert(data.message);
            //window.location.reload();
            setRemark("");
            setSelectedItem(null);

            handleSearch();
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };


    const getApprovalLevel = (item) => {
        const currentUserName = (userName || "").trim().toLowerCase();

        const level1Users = (item.level1UserName || "")
            .split(";")
            .map(x => x.trim().toLowerCase())
            .filter(Boolean);

        const level2Users = (item.level2UserName || "")
            .split(";")
            .map(x => x.trim().toLowerCase())
            .filter(Boolean);

        if (level1Users.includes(currentUserName)) {
            return 1;
        }

        if (level2Users.includes(currentUserName)) {
            return 2;
        }

        return 0;
    };

    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Dashboard</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/approval" className="text-muted text-hover-primary">Approval</a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
            </div>

            <section className='wraper'>
                <div className='box_shadow mt-14'>
                    <div class="row">
                        <div className="col-md-3 mb-3">
                            <label>From Date</label>
                            <input
                                type="text"
                                id="fromDate"
                                className="form-control"
                                placeholder="From Date"
                                readOnly
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label>To Date</label>
                            <input
                                type="text"
                                id="toDate"
                                className="form-control"
                                placeholder="To Date"
                                readOnly
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <div className="form-group">
                                <label className="">Status</label>
                                <select className="form-select form-select-solid"
                                    name="status"
                                    value={filters.status}
                                    onChange={handleChange}
                                >
                                    <option value="ALL">ALL</option>
                                    <option value="Requested">Requested</option>
                                    <option value="Rejected">Rejected</option>
                                    <option value="Accepted">Accepted</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3 mb-3">
                            <button
                                type="button"
                                className="btn btn-primary mt-7"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>

                    </div>
                </div>

                <div className='box_shadow mt-3'>
                    <div class="row">
                        <div class="col-md-12">
                            <h1 className='PendingApproval'>Queue</h1>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead>
                                        <tr class="fw-bold bg-light">
                                            <th class="ps-4">Sr No</th>
                                            <th>Traveler Name</th>
                                            <th>Reference No</th>
                                            <th>Origin</th>
                                            <th>Destination</th>
                                            <th>Journey Date</th>
                                            <th>Product</th>
                                            <th>Amount</th>
                                            <th>Requested By</th>
                                            {/* <th className='text-center'>Status</th> */}
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {approvals.length > 0 ? (
                                            approvals.map((item, index) => (
                                                <tr key={index}>
                                                    <td class="ps-4">{index + 1}</td>
                                                    <td>{item.travellerName}</td>
                                                    <td>
                                                        <a
                                                            href={`/dashboard/approval/Approval-detail?referenceNo=${encodeURIComponent(item.referenceNo)}&productType=${encodeURIComponent(item.product)}`}
                                                            className="view_detals"
                                                            title="details"
                                                            style={{ color: "#0d6efd", cursor: "pointer" }}
                                                        >
                                                            {item.referenceNo}
                                                        </a>
                                                    </td>
                                                    <td>{item.origin}</td>
                                                    <td>{item.destination}</td>
                                                    <td>
                                                        {item.departureDate}
                                                    </td>
                                                    <td>{item.product}</td>
                                                    <td><i className='fa fa-inr'></i> {item.totalFare}</td>
                                                    <td>{item.userId}</td>
                                                    {/* <td>{item.level1ApprovalStatus}</td> */}
                                                    <td className="view_img_icon">
                                                        {/* {item.level1ApprovalStatus === "Requested" && item.level2ApprovalStatus === "Requested" ? (
                                                            <>
                                                                <button
                                                                    className="btn btn-primary m-1"
                                                                    onClick={() =>
                                                                        SubmitAcceptApprovalRequest(item)
                                                                    }
                                                                >
                                                                    Approve
                                                                </button>
                                                                <button className='btn btn-primary m-1' data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => setSelectedItem(item)}>Reject</button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {item.level1ApprovalStatus === "Rejected" || item.level2ApprovalStatus === "Rejected" ? (
                                                                    <span style={{ color: "red" }}>Rejected</span>
                                                                ) : item.level1ApprovalStatus === "Accepted" ? (
                                                                    <span style={{ color: "green" }}>Approved</span>
                                                                ) : (
                                                                    <span style={{ color: "orange" }}>Requested</span>
                                                                )}
                                                            </>
                                                        )
                                                        } */}
                                                        {/* {(
                                                            item.level1ApprovalStatus === "Requested" ||
                                                            (
                                                                item.level1ApprovalStatus === "Approved" &&
                                                                item.level2ApprovalStatus === "Requested"
                                                            )
                                                        ) ? (
                                                            <>
                                                                <button
                                                                    className="btn btn-primary m-1"
                                                                    onClick={() => SubmitAcceptApprovalRequest(item)}
                                                                >
                                                                    Approve
                                                                </button>

                                                                <button
                                                                    className="btn btn-primary m-1"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#myModal"
                                                                    onClick={() => setSelectedItem(item)}
                                                                >
                                                                    Reject
                                                                </button>
                                                            </>
                                                        ) : item.level1ApprovalStatus === "Rejected" ||
                                                            item.level2ApprovalStatus === "Rejected" ? (
                                                            <span style={{ color: "red" }}>
                                                                Rejected
                                                            </span>
                                                        ) : item.level1ApprovalStatus === "Approved" &&
                                                            item.level2ApprovalStatus === "Approved" ? (
                                                            <span style={{ color: "green" }}>
                                                                Approved
                                                            </span>
                                                        ) : item.level2ApprovalStatus ? (
                                                            <span style={{ color: "orange" }}>
                                                                {item.level2ApprovalStatus}
                                                            </span>
                                                        ) : (
                                                            <span style={{ color: "orange" }}>
                                                                {item.level1ApprovalStatus}
                                                            </span>
                                                        )} */}

                                                        {(() => {
                                                            const approvalLevel = getApprovalLevel(item);

                                                            const currentStatus =
                                                                approvalLevel === 1
                                                                    ? item.level1ApprovalStatus
                                                                    : approvalLevel === 2
                                                                        ? item.level2ApprovalStatus
                                                                        : null;

                                                            if (currentStatus === "Requested") {
                                                                return (
                                                                    <>
                                                                        <button
                                                                            className="btn btn-primary m-1"
                                                                            onClick={() => SubmitAcceptApprovalRequest(item)}
                                                                        >
                                                                            Approve
                                                                        </button>

                                                                        <button
                                                                            className="btn btn-primary m-1"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#myModal"
                                                                            onClick={() => setSelectedItem(item)}
                                                                        >
                                                                            Reject
                                                                        </button>
                                                                    </>
                                                                );
                                                            }

                                                            if (currentStatus === "Rejected") {
                                                                return (
                                                                    <span style={{ color: "red" }}>
                                                                        Rejected
                                                                    </span>
                                                                );
                                                            }

                                                            if (currentStatus === "Approved") {
                                                                return (
                                                                    <span style={{ color: "green" }}>
                                                                        Approved
                                                                    </span>
                                                                );
                                                            }

                                                            return (
                                                                <span style={{ color: "orange" }}>
                                                                    {currentStatus || "Pending"}
                                                                </span>
                                                            );
                                                        })()}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="13" className="text-center text-muted">
                                                    {loading ? "Loading..." : "No records found"}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="myModal">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">Cancel Request</h4>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                            </div>

                            <div class="modal-body">
                                <div className='col-md-12'>
                                    <label>Why Cancel ?</label>
                                    <textarea className='form-controls' placeholder='Write Reason..' cols={80} rows={4}
                                        value={remark}
                                        onChange={(e) => setRemark(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className='col-md-12 text-end'>
                                    {/* <button className='btn btn-primary'>Submit Request</button> */}
                                    <button
                                        className="btn btn-danger"
                                        onClick={() =>
                                            SubmitRejectApprovalRequest(selectedItem)
                                        }
                                    >
                                        Submit Request
                                    </button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default Approval;